(ns manage.feed-importer-ocp.view
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/AlertTitle$default" :as AlertTitle]
            ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Tab$default" :as Tab]
            ["@mui/material/Tabs$default" :as Tabs]
            [common.ocp.view :refer [defocp ocp]]
            [common.widgets.asset-upload :as upload]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [common.widgets.menu :refer [menu]]
            [common.widgets.radio :refer [radio-group]]
            [linked.core :as l]
            [manage.feed-importer-ocp.db :as form]
            [manage.feed-lookup-table.view :as lookup-table]
            [manage.feed-mapping-table.view :as mapping-table]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [defui $]]
            [uix.re-frame :refer [use-subscribe]]))

(defui content-tab []
  ($ Stack {:p 3 :spacing 3}
     ($ form-field
        {:label "Name"
         :err-msg (form/use-error-message [:name])
         :data-testid "feed-name-input"}
        ($ input (form/use-bind-control [:name])))
     ($ :p "Configure your source by entering your URL or uploading your sheet")
     ($ form-field
        {:label "URL"
         :err-msg (form/use-error-message [:url])
         :data-testid "feed-url-input"}
        ($ input (form/use-bind-control [:url])))
     ($ upload/upload
        {:enableEdit false
         :resumable? true
         :onChange #(rf/dispatch [:form.feed-importer/on-change :url %])
         :path [::asset]
         :extensions ".json, .csv"})))

(defui authentication-tab []
  ($ Stack {:p 3 :spacing 3}
     ($ form-field
        {:label "Authentication type"
         :err-msg (form/use-error-message [:api-key-field-type])
         :data-testid :api-key-field-type-input}
        (r/as-element
         [radio-group
          (merge (form/use-bind-control [:api-key-field-type])
                 {:options [{:label "None"
                             :value "none"
                             :id :none
                             :data-testid "auth-tab-none-radio-button"}
                            {:label "Query Parameter"
                             :value "query-parameter"
                             :id :query-parameter
                             :data-testid "auth-tab-query-radio-button"}
                            {:label "Header Parameter"
                             :value "header-parameter"
                             :id :header-parameter
                             :data-testid "auth-tab-header-radio-button"}]})]))
     ($ form-field
        {:label "API key name"
         :err-msg (form/use-error-message [:api-key-field-name])
         :data-testid :feed-api-field-name-input}
        ($ input (form/use-bind-control [:api-key-field-name])))
     ($ form-field
        {:label "API key secret"
         :err-msg (form/use-error-message [:api-key])
         :data-testid :feed-api-key-input}
        ($ input (form/use-bind-control [:api-key])))))

(defui mapping-tab []
  (let [url (use-subscribe [:form.feed-importer/url])
        sku-error (form/use-error-message [:meta :sku])
        raw-mappings-errors (use-subscribe [:form.feed-importer/raw-mapping-errors])]
    (if (not-empty url)
      ($ :<>
         (when sku-error
           ($ Alert
              {:severity "warning"}
              sku-error))
         (when-some [error-message (first raw-mappings-errors)]
           (case error-message
             "The fields should have unique names"
             ($ Alert
                {:severity "warning"
                 :sx #js {:m 2}}
                ($ AlertTitle ($ :strong "Duplicate names detected"))
                "Two or more of your fields have the same name. Make sure your field names are unique to continue.")

             nil))
         ($ mapping-table/table))
      ($ Box {:p 3}
         ($ :span {:data-testid :mapping-tab-no-mapping}
            "We could not load any feed data, please provide a valid feed in the previous step.")))))

(defui lookup-tab []
  (let [url (use-subscribe [:form.feed-importer/url])]
    (if (not-empty url)
      ($ lookup-table/table {:value-sub :table.feed-lookup/value
                             :show-latlon? true
                             :show-postcode? true})
      ($ Box {:p 3}
         ($ :span {:data-testid :lookup-tab-no-mapping}
            "We could not load any feed data, please provide a valid feed in the previous step.")))))

(defui scheduling-tab
  [{:keys [bind-control-fn interval-options schedule-error-message-fn timezone-error-message-fn timezone-string-fn interval-test-id timezone-test-id]
    :or {bind-control-fn #(form/use-bind-control [:schedule])
         interval-options form/interval-options
         schedule-error-message-fn #(form/use-error-message [:schedule])
         timezone-error-message-fn #(form/use-error-message [:timezone])
         timezone-string-fn #(form/timezone-string)
         interval-test-id :feed-importer-schedule-interval
         timezone-test-id :feed-importer-timezone}}]
  ($ Stack
     {:p 3 :spacing 3}
     ($ form-field
        {:label "Schedule interval"
         :err-msg (schedule-error-message-fn)
         :data-testid interval-test-id}
        (r/as-element
         [radio-group
          (merge (bind-control-fn)
                 {:options interval-options})]))
     ($ form-field
        {:label "Timezone"
         :err-msg (timezone-error-message-fn)
         :data-testid timezone-test-id}
        ($ :span (timezone-string-fn)))))

(def tab-info
  {:label "Information"
   :button-label "Save and continue →"
   :content ($ content-tab)
   :next-tab :authentication
   :data-testid "information-tab-button"})

(def tab-authentication
  {:label "Authentication"
   :button-label "Save and continue →"
   :content ($ authentication-tab)
   :next-tab :mapping
   :data-testid "authentication-tab-button"})

(def tab-mapping
  {:label "Mapping"
   :button-label "Save and continue →"
   :content ($ mapping-tab)
   :data-testid "mapping-tab-button"})

(def tab-lookup
  {:label "Lookup"
   :button-label "Save and continue →"
   :content ($ lookup-tab)
   :next-tab :scheduling
   :data-testid "lookup-tab-button"})

(def tab-scheduling
  {:label "Scheduling"
   :button-label "Save and run feed importer"
   :content ($ scheduling-tab)
   :data-testid "scheduling-tab-button"})

(def product-tabs
  (l/map :information tab-info
         :authentication tab-authentication
         :mapping (assoc tab-mapping :next-tab :scheduling)
         :scheduling tab-scheduling))

(def lookup-tabs
  (l/map :information tab-info
         :authentication tab-authentication
         :mapping (assoc tab-mapping :next-tab :lookup)
         :lookup tab-lookup
         :scheduling tab-scheduling))

(def title
  {:lookup {:create "Add a new Dynamic feed"
            :edit "Edit Dynamic feed"}
   :product {:create "Add a new Product feed importer"
             :edit "Edit Product feed importer"}})

(defocp feed-crud :feed/crud
  {:width "60%"
   :disable-padding true}
  []
  (let [type (use-subscribe [:table.feed/feed-type])
        allowed-to-edit? (use-subscribe [:resource.user/allowed? "adsets2.edit"])
        edit-mode (use-subscribe [:form.feed-importer/edit-mode])
        submenu [{:label "Delete Dynamic feed"
                  :icon "delete"
                  :on-click #(rf/dispatch [:form.feed-importer/delete-feed])}]
        tabs (case type
               :lookup lookup-tabs
               :product product-tabs
               nil)
        [active-tab set-active-tab] (uix/use-state :information)
        current (get tabs active-tab)
        show-all-errors? (use-subscribe [:form.feed-importer/show-all-errors?])
        form-has-errors? (use-subscribe [:form.feed-importer/errors? (not show-all-errors?)])]
    ($ ocp
       {:title (get-in title [type edit-mode])
        :submenu (when (and (= edit-mode :edit) allowed-to-edit?)
                   ($ menu
                      {:icon "more_vert"
                       :items submenu}))
        :on-submit (fn []
                     ;; Previously submit button on-click triggered this together
                     ;; with the regular on-submit event, so this should match the
                     ;; old version.
                     (when (= :lookup active-tab)
                       (rf/dispatch [:form.feed-importer/save-lookup]))
                     (let [next-tab (fn []
                                      (when-let [k (:next-tab current)]
                                        (set-active-tab k)
                                        k))]
                       (rf/dispatch [:form.feed-importer/submit next-tab])))
        :header ($ Tabs
                   {:value active-tab
                    :onChange (fn [_e v] (set-active-tab (keyword v)))
                    :sx #js {:px 3
                             :backgroundColor "grey.90"}
                    :variant "scrollable"}
                   (for [[k v] tabs]
                     ($ Tab
                        {:key k
                         :value k
                         :label (:label v)
                         :data-testid (:data-testid v)})))
        :footer ($ Button
                   {:variant "contained"
                    :type "submit"
                    :disabled (or (not allowed-to-edit?)
                                  form-has-errors?)
                    :data-testid "footer-ok-button"}
                   (:button-label current))}
       (:content current))))
